(angular => {
  "use strict";


  angular.module("EventCompanyEmployee").controller("EventCompanyEmployee.ListCtrl", [
    "$scope",
    "$timeout",
    "Loader",
    "Toast",
    "EventService",
    "EventCompanyService",
    "EventCompanyEmployeeService",
    ListCtrl
  ]);

  function ListCtrl($scope, $timeout, Loader, Toast, eventService, eventCompanyService, eventCompanyEmployeeService) {
    let queryTimeout = null;
    this.promise = null;
    this.exhibitors = [];
    this.pagination = { page: 1, limit: 10 };

    eventService.current().then(event => {
      this.event = event;
    });

    this.load = () => {
      this.promise = eventCompanyService.listExhibitors().then(exhibitors => {
        this.exhibitors = exhibitors;
      }).catch(err => Toast.httpHandler(err));
    };

    this.exportTickets = () => {
      eventCompanyEmployeeService.exportList();
    };

    this.onPaginate = () => {
      $scope.$emit("scroll-top");
    };

    $scope.$watch(() => this.query, () => {
      $timeout.cancel(queryTimeout);
      queryTimeout = $timeout(() => this.load(), 500);
    }, true);

  }
})(angular || {});
